import { DisableBodyScrollProvider } from "@naf/teamscheme";
import type { ReactNode } from "react";
import { SignalRClientProvider } from "../api/SignalRClientProvider";
import { Auth0AuthProvider } from "../auth/AuthProvider";
import CustomerProvider from "../auth/CustomerProvider";
import Providers from "../shared/Providers";
import { BottomPanelProvider } from "../shared/layout/BottomPanel";
import { HeaderAlertsProvider } from "../shared/layout/header/HeaderAlert";
import { LayoutContextProvider as LayoutProvider } from "../shared/layout/LayoutContext";
import { HeaderWithProgressProvider } from "../shared/layout/header/HeaderWithProgressProvider";
import { TrackPageViews } from "../report/TrackPageViews";

export function AppWrapper({ children }: { children: ReactNode }) {
  return <Providers providers={PROVIDERS}>{children}</Providers>;
}

const PROVIDERS = [
  { key: "DisableBodyScrollProvider", Component: DisableBodyScrollProvider },
  { key: "LayoutProvider", Component: LayoutProvider },
  { key: "TrackPageViews", Component: TrackPageViews },
  { key: "BottomPanelProvider", Component: BottomPanelProvider },
  { key: "SignalRClientProvider", Component: SignalRClientProvider },
  { key: "AuthProvider", Component: Auth0AuthProvider },
  { key: "CustomerProvider", Component: CustomerProvider },
  { key: "HeaderAlertsProvider", Component: HeaderAlertsProvider },
  { key: "HeaderWithProgressProvider", Component: HeaderWithProgressProvider },
];
